import { render, staticRenderFns } from "./SchoolyearStudyCostAddEdit.vue?vue&type=template&id=572d4d03"
import script from "./SchoolyearStudyCostAddEdit.vue?vue&type=script&lang=js"
export * from "./SchoolyearStudyCostAddEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports